<script lang="ts">
import { evaArrowCircleUpOutline } from '@quasar/extras/eva-icons'
import { defineComponent, onMounted, reactive } from 'vue'
import { handleScroll } from '~/utils'

type Data = {
  showButton: boolean
}

export default defineComponent({
  setup() {
    const data = reactive<Data>({ showButton: false })

    onMounted(() => {
      window.addEventListener('scroll', () => {
        window.scrollY > 500 ? (data.showButton = true) : (data.showButton = false)
      })
    })
    return {
      evaArrowCircleUpOutline,
      top: () => handleScroll('app-header'),
      data,
    }
  },
})
</script>

<template>
  <q-icon
    class="up"
    :class="{ show: data.showButton }"
    :name="evaArrowCircleUpOutline"
    @click="top"
  >
    <q-tooltip anchor="top right" self="bottom middle">
      go top
    </q-tooltip>
  </q-icon>
</template>

<style lang="scss">
  .up {
  position: fixed;
  z-index: 10000;
  bottom: 42px;
  right: 55px;
  cursor: pointer;
  display: none;

  @media (max-width: $breakpoint-xs) {
    bottom: 106px;
    right: 45px;
  }

  svg {
    width: 50px;
    height: 50px;
    fill: #d7d7d76b;
    transition: 0.1s ease-in-out;
  }

  &:hover svg {
    transform: scale(1.2);
    fill: rgba(0, 0, 0, 0.753);
  }
}
.show {
  display: block;
}
</style>
